/**
 * Backend API base URL.
 * Set in betmate-website/.env: REACT_APP_API_BASE_URL=...
 * When the site is opened on localhost, defaults to local backend (5001).
 */
const LOCAL_API = "http://localhost:5001";
const PROD_API = "https://api.betbond.app";

function resolveApiBaseUrl() {
  const envUrl = process.env.REACT_APP_API_BASE_URL;
  if (envUrl) return envUrl;

  const onLocalHost =
    typeof window !== "undefined" &&
    /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname);

  if (onLocalHost) return LOCAL_API;

  return PROD_API;
}

export const API_BASE_URL = resolveApiBaseUrl();
